module.exports = __webpack_public_path__ + "files/9258a0302a0235c0466d32bf42c1712c.png";